import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
// import {
//   FLUSH,
//   PAUSE,
//   PERSIST,
//   persistReducer,
//   persistStore,
//   PURGE,
//   REGISTER,
//   REHYDRATE
// } from "redux-persist";
import globalSlice, { userSlice, RoleMenuSlice } from "./modules/globalSlice";

const rootReducer = combineReducers({
  global: globalSlice,
  user: userSlice.reducer,
  MenuActive: RoleMenuSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
});

// export const persistor = persistStore(store);

export default store;
